module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/logo_eight-a5151df0e5a7aac51f4bdf2bc6b59130.svg";